import React, { useEffect } from 'react';
import { MockAuthProvider } from '../context/MockAuthProvider';
import MainLayout from '../components/layout/MainLayout';
import { useToolStore } from '../store/useToolStore';
import { Outlet } from 'react-router-dom';

// We want to force certain initial states for the trial
const DataInitializer = () => {
    const setUploadedImage = useToolStore(state => state.setUploadedImage);
    const setHistory = useToolStore(state => state.setHistory);
    const setHistoryIndex = useToolStore(state => state.setHistoryIndex);

    useEffect(() => {
        // Reset and Load Demo Data
        // Use a nice architectural placeholder
        const demoImage = "https://images.unsplash.com/photo-1600607686527-6fb886090705?q=80&w=2000&auto=format&fit=crop";

        setUploadedImage(demoImage);
        setHistory([demoImage]);
        setHistoryIndex(0);

        // Cleanup on unmount to ensure no state leaks if they somehow navigate back
        return () => {
            setUploadedImage(null);
            setHistory([]);
            setHistoryIndex(-1);
        };
    }, [setUploadedImage, setHistory, setHistoryIndex]);

    return null;
}

const DemoBanner = () => (
    <div className="bg-gradient-to-r from-indigo-900 via-purple-900 to-indigo-900 text-white text-center py-2 px-4 text-xs font-medium tracking-wide border-b border-indigo-700/50 shadow-lg relative z-50">
        <span className="opacity-90">✨ TRIAL MODE • Experience the power of Dotting • Local Browser Session</span>
        <a href="/register" className="ml-4 underline hover:text-indigo-200 transition-colors">Create Account to Save Work</a>
    </div>
);

const TrialLayout: React.FC = () => {
    return (
        <MockAuthProvider>
            <DataInitializer />
            <div className="flex flex-col h-screen overflow-hidden">
                <DemoBanner />
                <div className="flex-1 relative overflow-hidden">
                    <MainLayout />
                </div>
            </div>
        </MockAuthProvider>
    );
};

export default TrialLayout;
